module.exports = __webpack_public_path__ + "img/分组 33.bc4ea28d.png";